import { userInfoAtom } from 'app/atoms';
import { useOnboarding } from 'app/hooks/use-onboarding';
import { useCreateGuidelines, useUser } from 'app/network/user';
import type { CreateGuidelinesDTO } from 'app/types/user';
import { WhiteLabel } from 'app/types/white-labels';
import { isWhiteLabel } from 'app/utils/helpers';
import { useAtomValue } from 'jotai/index';

import type { UseFormHandleSubmit } from 'react-hook-form';

export function useGuidelinesFlow({ handleSubmit }: { handleSubmit: UseFormHandleSubmit<CreateGuidelinesDTO> }) {
  const { goToNext } = useOnboarding();
  const userInfo = useAtomValue(userInfoAtom);
  const { data: user } = useUser();
  const { mutate, isPending: isLoading } = useCreateGuidelines();

  const bullets = ((): string[] => {
    if (userInfo?.type === 'public') {
      return ['firstParagraph', 'secondParagraphPublic', 'thirdParagraphPublic'];
    }
    return [
      'firstParagraph',
      user?.insured ? 'secondParagraphInsured' : 'secondParagraph',
      'thirdParagraph',
      'fourthParagraph',
      ...(!isWhiteLabel(WhiteLabel.HauteGaspesie) ? ['fifthParagraph'] : []),
    ];
  })();

  const onSubmit = handleSubmit((form) => {
    mutate(form, {
      onSuccess: () => {
        goToNext();
      },
    });
  });

  return { bullets, isLoading, onSubmit, user };
}
